<div class="d-sm-flex">
  <div *ngIf="showLogo" class="text-center logo-flights">
    <img
      src="https://www.gstatic.com/flights/airline_logos/70px/{{segment.marketingAirline.code}}.png"
      alt="{{ segment.operatingAirline.code }}"
      class="flight-company-logo">
    <h6 class = "flight-number">
      {{ segment.marketingAirline.code }}
      {{ segment.flightNumber }}
    </h6>
  </div>

  <div class="text-center flex-grow-1">
    <div *ngIf="isArrival(); then describeArrival; else describeDeparture"></div>

    <ng-template #describeArrival>
      <h6>{{ segment.arrival.iata }}</h6>
      <h4>{{ segment.arrival.hour }}</h4>
      <p class="date-flight-small">{{ segment.arrival.date | localizedDate : "EEEE d MMMM" }}</p>
      <h6>{{ segment.arrival.airportName }}</h6>
      <!-- <ng-container *ngIf="segment.technicalStopover">
        <ng-container *ngIf="segment.technicalStopover.noInfo; else stopoverDetails">
          <p class="technical-stopover">(*) include scalo tecnico</p>
        </ng-container>
        <ng-template #stopoverDetails>
          <p class="technical-stopover">
            (*) include scalo tecnico a {{ segment.technicalStopover.locationName }}, arrivo {{ segment.technicalStopover.arrival }}, partenza {{ segment.technicalStopover.departure }}
          </p>
        </ng-template>
      </ng-container> -->
    </ng-template>

    <ng-template #describeDeparture>
      <h6>{{ segment.departure.iata }}</h6>
      <h4>{{ segment.departure.hour }}</h4>
      <p class="date-flight-small">{{ segment.departure.date | localizedDate : "EEEE d MMMM" }}</p>
      <h6>{{ segment.departure.airportName }}</h6>
      <!-- <ng-container *ngIf="segment.technicalStopover">
        <ng-container *ngIf="segment.technicalStopover.noInfo; else stopoverDetailsDep">
          <p class="technical-stopover">(*) include scalo tecnico</p>
        </ng-container>
        <ng-template #stopoverDetailsDep>
          <p class="technical-stopover">
            (*) include scalo tecnico a {{ segment.technicalStopover.locationName }}, arrivo {{ segment.technicalStopover.arrival }}, partenza {{ segment.technicalStopover.departure }}
          </p>
        </ng-template>
      </ng-container> -->
    </ng-template>
  </div>
</div>
